import api from "@/services/api";
import { ENDPOINTS_DASHBOARD } from "@/services/endpoints";

export const getDashboard = () => api.get(ENDPOINTS_DASHBOARD.get).then((r) => r.data);
